import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Button } from "@remo-co/ui-core/src/components/Button";
import classNames from "classnames";
import { useI18n } from "i18n";
import StatusBadge from "./StatusBadge";
import { useStyles } from "./styles";
import { ISsoStatus } from "./SsoConfiguration";
import InfoReadonlyFieldValue from "./InfoReadonlyFieldValue";
import { ISsoInfo } from "./types";

export interface IInfoViewProps {
  ssoStatus: ISsoStatus;
  configInfo: ISsoInfo;
  onToggleInfoEditing: () => void;
}

const InfoView = ({
  ssoStatus,
  configInfo,
  onToggleInfoEditing,
}: IInfoViewProps) => {
  const classes = useStyles();
  const { t } = useI18n(["common", "sso"]);

  return (
    <>
      <div
        className={classNames(
          classes.split,
          classes.spacing,
          classes.bottomBorder,
        )}
      >
        <div>
          <Typography variant="h6">
            <strong>{t("sso:info.view.title")}</strong>
          </Typography>
          <StatusBadge status={ssoStatus} />
        </div>
        <Button
          variant="secondary"
          color="dark"
          onClick={onToggleInfoEditing}
          size="md"
        >
          {t("button.edit")}
        </Button>
      </div>

      <div className={classNames(classes.spacing)}>
        <InfoReadonlyFieldValue
          title={t("sso:display.name")}
          value={configInfo.displayName}
          siblingEl={
            configInfo.providerId ? (
              <Typography variant="caption">
                {t("sso:provider.id")}: {configInfo.providerId}
              </Typography>
            ) : null
          }
        />

        <InfoReadonlyFieldValue
          title={t("sso:authentication.endpoint")}
          value={configInfo.authenticationEndpoint}
        />
        <InfoReadonlyFieldValue
          title={t("sso:identity.provider.entity.id")}
          value={configInfo.identityProviderEntityID}
        />

        <InfoReadonlyFieldValue
          title={t("sso:public.certificate")}
          value={t("sso:edit.to.view")}
        />
      </div>
    </>
  );
};

export default InfoView;
